export const MORALIS_SERVER_ID = "https://p0zj4plzl7yv.usemoralis.com:2053/server";

export const MORALIS_APP_ID = "9mLyP0kuz3sUAJZrGU2aULTo82eDD0kRboqgM4yB";
